module.exports = __webpack_public_path__ + "img/merac.120c9ff1.png";